import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/networkId/networkId.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import { FormLayout } from 'components/FormLayout';
import './network-id-form.scss';

type Props = {
template: FormTemplate,
data: Partial<types.NetworkId>
i18nKeyPrefix?: string
isEditing?: boolean,
section: string
onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
}

export type Ref = {
    isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
    getValues: () => types.NetworkId
  }

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'networkId.form';

const NetworkIdForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  section,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const sectionRef = useRef<Form>(null);
  //   const [templateSection, setTemplateSection] = useState<FormTemplateSection | string>('');

  //   useEffect(() => {
  //     const templateSec = section === 'main' ? template.main : template.portRange;

  //     console.log({ section, templateSection });
  //     setTemplateSection(templateSec);
  //   }, [section]);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isSectionValid = sectionRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isSectionValid;
  };

  const getValues = () => {
    const formValues: types.NetworkId = {
      ...sectionRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="utimaco-packet-switch-form" data-testid="networkIdForm" id="networkIdForm">
      <div data-testid={`networkIdForm${section}`}>
        <FormLayout>
          <Form
            ref={sectionRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template[section] as FormTemplateSection)?.fields}
            layout={(template[section] as FormTemplateSection)?.metadata?.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default NetworkIdForm;
